import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UpgradeNg1Helpers } from './../shared/helpers/upgrade/upgrade-ng1.helper';
import { V3StudentContainerModule } from './student-container/student-container.module';
import { StudentComponent } from './student.component';

@NgModule({
  declarations: [
    StudentComponent,
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'student-container',
      inputs: [
        'currentStudent',
        'currentUser',
        'channel',
        'currentSchool',
        'studentDiffs',
        'filteredStudents',
        'schoolUsers',
        'students',
        'studentSupports',
        'parsedFilterParam',
        'parsedSortParam',
        'studentGapPlans',
        'isRestricted',
      ],
    }),
  ],
  imports: [CommonModule, V3StudentContainerModule],
  exports: [StudentComponent],
  providers: [],
})
export class StudentModule {}
